<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "border rounded mt-2 p-1" }, [
    _c(
      "div",
      { staticClass: "dispute-text mt-2" },
      [
        _vm._v(
          " " +
            _vm._s(
              _vm.isCounterParty
                ? _vm.$t("disputeStatus.KindlyReplyToTheDisputeWithin")
                : _vm.$t("disputeStatus.Counterparty-replied")
            ) +
            " "
        ),
        _c("b-link", [_vm._v(_vm._s(_vm.remainingTime))]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "mt-2" },
      [
        _c(
          "b-alert",
          { staticClass: "d-flex", attrs: { variant: "primary", show: "" } },
          [
            _c(
              "div",
              [
                _c("feather-icon", {
                  staticClass: "m-1",
                  attrs: { icon: "AlertCircleIcon", size: "16" },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "counterparty-alert" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.isCounterParty
                      ? _vm.$t("disputeStatus.disputeAlert")
                      : _vm.$t("disputeStatus.Counterparty-Alert")
                  ) +
                  " "
              ),
            ]),
          ]
        ),
      ],
      1
    ),
    _vm.isCounterParty
      ? _c("ol", { staticClass: "ol-text mt-1" }, [
          _c("li", [
            _vm._v(
              " " + _vm._s(_vm.$t("disputeStatus.CounterPartyStatement1")) + " "
            ),
          ]),
          _c("li", [
            _vm._v(
              " " + _vm._s(_vm.$t("disputeStatus.CounterPartyStatement2")) + " "
            ),
          ]),
          _c("li", [
            _vm._v(
              " " + _vm._s(_vm.$t("disputeStatus.CounterPartyStatement3")) + " "
            ),
          ]),
          _c("li", [
            _vm._v(
              " " + _vm._s(_vm.$t("disputeStatus.CounterPartyStatement4")) + " "
            ),
          ]),
        ])
      : _c("ol", { staticClass: "ol-text mt-1" }, [
          _c("li", [
            _vm._v(" " + _vm._s(_vm.$t("disputeStatus.Statement1")) + " "),
          ]),
          _c("li", [
            _vm._v(" " + _vm._s(_vm.$t("disputeStatus.Statement2")) + " "),
          ]),
          _c("li", [
            _vm._v(" " + _vm._s(_vm.$t("disputeStatus.Statement3")) + " "),
          ]),
        ]),
    _c(
      "div",
      { staticClass: "mt-2" },
      [
        _c(
          "b-button",
          {
            staticClass: "mr-2",
            attrs: { variant: "primary" },
            on: {
              click: function ($event) {
                return _vm.callUpdateAgreementReachedApi()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("disputeStatus.AgreementReached")))]
        ),
        _c(
          "b-button",
          {
            attrs: { variant: "danger" },
            on: {
              click: function ($event) {
                return _vm.updateDispute("NEGOTIATION_FAILED")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("disputeStatus.NegotiationFailed")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/components/dispute/NegotiationFailed.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default ({
  render,
  staticRenderFns,
  components: {
    BButton: bootstrapvue["BButton"],
    BLink: bootstrapvue["BLink"],
    BAlert: bootstrapvue["BAlert"]
  },
  props: {
    remainingTime: {
      type: String,
      default: ""
    },
    isCounterParty: {
      type: Boolean,
      default: true
    },
    updateDispute: {
      type: Function,
      default: () => {}
    },
    adOrderDispute: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    callUpdateAgreementReachedApi() {
      if (this.isCounterParty) {
        this.updateDispute("AGREEMENT_REACHED_REQUEST");
      } else {
        this.updateDispute("AGREEMENT_REACHED");
      }
    }
  }
});

//# sourceURL=webpack:///./src/@core/components/dispute/NegotiationFailed.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

